import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getProductsByBrand,
  getProductsByCategory,
} from 'aster-foundation/core/epharmacy/Product/redux/action';
import { Container } from 'react-bootstrap';
import {
  getConfigurationValueByFilter,
  getJSONParseValue,
  removeDuplicates,
  sortArrayResponseAsc,
} from '@common/Utility/common-utils';
import { ONLINE_PHARMACY_ROUTE, PRODUCT_RECOMMENDATION_DATA } from '@common/Utility/constants';
import RichMediaBanners from './PDPComponents/RichMediaBanners';
import ProductDetailsStyled from './ProductDetailsStyled';
import callNewRecommendationApi from '../CommonCarouselCall';
import CommonProductCarousel from '@common/Component/CommonProductCarousel/CommonProductCarousel';
import InsiderRecCarousel from '@common/Component/InsiderRecommenderCarousel/InsiderRecCarousel';
import { flagsmith } from '@common/Lib/Flagsmith';
import { useRouter } from 'next/router';
import { setInsiderObj } from './redux/reducer';
import { useTranslation } from '@common/i18n';

const ProductBottom = ({
  skuId,
  catId,
  brandId,
  detailsData,
  referrerPage,
  scrollRef,
  fbtCondition,
  pdpUpSellingFlag,
  productId,
  setShowVideo,
  showVideo,
  setSelectedMediaId,
  selectedMediaID,
  analyticsProps,
  catLID,
  catLID_name,
  emptySphValues = () => {}
}) => {
  const dispatch = useDispatch();
  const t = useTranslation();
  const { sku } = detailsData;
  const [categoryProducts, setCategoryProducts] = useState([]);
  const [brandProducts, setBrandProducts] = useState([]);
  const [firstCarouselData, setFirstCarouselData] = useState({});
  const [showBrandCarousel, setShowBrandCarousel] = useState(false);
  const [showCategoryCarousel, setShowCategoryCarousel] = useState(false);
  const [secondCarouselData, setSecondCarouselData] = useState([]);
  const [recommendationConfigData, setRecommendationConfigData] = useState([]);
  const [isLoading, setIsloading] = useState(true);
  const [isFallback, setIsFallback] = useState(false);
  const [isInsiderCalled, setIsInsiderCalled] = useState(false);
  const [insiderData, setInsiderData] = useState({});

  const router = useRouter();
  const zoneData = useSelector((state) => state?.app?.userLocationReducer?.zone);
  const appConfigData = useSelector((state) => state?.astercore?.AppConfig?.data?.data);
  const userLogin = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry?.[0]?.resource);
  const insiderReducer = useSelector((state) => state?.app?.pdpReducer?.insider);
  const guestLogin = useSelector((state) => state?.astercore?.guestAccessToken?.data);
  const ae_web_carousels = flagsmith.getValue('ae_web_carousels', { json: true });
  const insiderRecommendation = ae_web_carousels?.carousels_config?.pdp?.map(
    ({ insiderRecommendation }) => insiderRecommendation,
  );
  const asterRecommendation = ae_web_carousels?.carousels_config?.pdp?.map(
    ({ asterRecommendation }) => asterRecommendation,
  );

  const paramsNew = {
    pageSize: 10,
    pageFrom: 0,
    zone: zoneData?.join(','),
  };

  const getCategoryProducts = () => {
    if (catLID && catLID !== '' && zoneData?.length > 0) {
      setIsFallback(true);
      dispatch(
        getProductsByCategory({
          params: {
            id: catLID,
            query: paramsNew,
          },
          onSuccess: (res) => {
            setCategoryProducts(res);
          },
          onFailure: () => {},
        }),
      );
    }
  };

  const getBrandProducts = () => {
    if (brandId && brandId !== '' && zoneData?.length > 0) {
      setIsFallback(true);
      dispatch(
        getProductsByBrand({
          params: { id: brandId, query: paramsNew },
          onSuccess: (res) => {
            setBrandProducts(res);
          },
          onFailure: () => {},
        }),
      );
    }
  };

  useEffect(() => {
    if (appConfigData?.length > 0) {
      const configValue = getConfigurationValueByFilter(appConfigData, PRODUCT_RECOMMENDATION_DATA);
      if (configValue && configValue.length > 0) {
        const { active, value } = configValue?.[0];
        if (active === 'true' && value) {
          setRecommendationConfigData(getJSONParseValue(value) || []);
        }
      }
    }
  }, [appConfigData?.length]);

  const onSuccess = (response, item) => {
    const { title, offerType, position } = item;
    setIsloading(false);
    if (position === 1) {
      if (response.data && response.data.length > 0) {
        setFirstCarouselData({ ...response, position, title: title || response?.title, reOfferType: offerType });
      } else {
        getCategoryProducts();
      }
    } else if (position > 1) {
      if (response.data && response.data.length > 0) {
        setSecondCarouselData((prevState) => {
          const recommendationEngineResponse = [
            ...prevState,
            ...[{ ...response, position, title: title || response.title, reOfferType: offerType }],
          ];
          return sortArrayResponseAsc(removeDuplicates(recommendationEngineResponse, 'position'), 'position');
        });
      } else {
        getBrandProducts();
      }
    }
  };
  const onFailure = (err, item) => {
    setIsloading(false);
    if (err && item?.position === 1) {
      setFirstCarouselData({});
      getCategoryProducts();
    }
    if (err && item?.position > 1) {
      setSecondCarouselData([]);
      getBrandProducts();
    }
  };

  const checkInsider = () => {
    if (window.Insider) {
      window.Insider.eventManager.once('ins-sr:only-api-campaign:load', (event, data) => {
        const updatedInsiderObj = {};
        updatedInsiderObj[data?.campaignId] = data;
        window.insiderData = { ...window.insiderData, ...updatedInsiderObj };
        dispatch(setInsiderObj({
          insider: updatedInsiderObj
        }));
        // setInsiderData(window.insiderData);
      });
    } else {
      setTimeout(checkInsider, 500);
    }
  };

  useEffect(() => {
    window.insiderData = {};
    checkInsider();
  }, [router?.pathname]);

  useEffect(() => {
    recommendationConfigData?.map((item) =>
      callNewRecommendationApi(
        dispatch,
        { zoneData, userLogin, guestLogin },
        {
          offerType: item?.offerType,
          type: item?.type,
          item,
          productIds: productId,
          categoryId: catId,
          onSuccess,
          onFailure,
        },
      ),
    );
  }, [zoneData, userLogin, guestLogin, recommendationConfigData?.length, detailsData, sku]);

  const scrollToSecondCarousel =
    firstCarouselData &&
    Object.keys(firstCarouselData).length === 0 &&
    categoryProducts &&
    categoryProducts?.data?.length === 0;

  const firstProductCarouselCondition =
    ((firstCarouselData && firstCarouselData?.data?.length > 0) || categoryProducts) && !scrollToSecondCarousel;

  useEffect(() => {
    if (firstCarouselData && Object.keys(firstCarouselData).length === 0) {
      getCategoryProducts();
    }
    if (secondCarouselData && secondCarouselData.length === 0) {
      getBrandProducts();
    }
  }, [Object?.keys(firstCarouselData)?.length, secondCarouselData?.length, brandId, catId, zoneData]);

  const { title, showViewAll, type, reOfferType } = firstCarouselData;
  const firstCarouselListing = firstCarouselData?.data ? firstCarouselData : categoryProducts;

  const getViewAllLink = (item, type) => {
    if (type === 'category') {
      if (item?.metaData) {
        return `${ONLINE_PHARMACY_ROUTE}/c/${encodeURIComponent(item?.metaData?.name)}/${item?.metaData?.id}`;
      }
      return `${ONLINE_PHARMACY_ROUTE}/c/${encodeURIComponent(item?.id)}`;
    }
    if (type === 'brand') {
      if (item?.metaData) {
        return `${ONLINE_PHARMACY_ROUTE}/brand/${encodeURIComponent(brandProducts?.metaData?.name)}/${
          brandProducts?.metaData?.id
        }`;
      }
      return `${ONLINE_PHARMACY_ROUTE}/brand/${encodeURIComponent(item?.id)}`;
    }
    if (type === 'offerType') {
      return `${ONLINE_PHARMACY_ROUTE}/searchresult?offerType=${reOfferType}&title=${encodeURIComponent(item?.title)}`;
    }
    return ONLINE_PHARMACY_ROUTE;
  };

  useEffect(() => {
    if((showBrandCarousel)){
      getBrandProducts();
    }
    if(showCategoryCarousel){
      getCategoryProducts();
    }
  }, [showBrandCarousel,showCategoryCarousel,brandId]);

  return (
    <ProductDetailsStyled>
      {showBrandCarousel ? (
        (brandProducts && brandProducts?.data?.length > 4) && (
          <CommonProductCarousel
            brandId={brandId}
            title={`${t('ProductDetail.moreFrom')} ${brandProducts?.metaData?.name}`}
            isLoading={isLoading}
            data={{ productList: brandProducts }}
            viewAllLink={`${ONLINE_PHARMACY_ROUTE}/brand/${encodeURIComponent(brandProducts?.metaData?.name)}/${
              brandProducts?.metaData?.id
            }`}
            page={referrerPage}
            showViewAllLink={brandProducts?.data?.length > 5}
            emptySphValues={emptySphValues}
          />
        )
      ) : (
        <InsiderRecCarousel
          insiderRecommendation={insiderRecommendation?.[0]}
          variationId={insiderRecommendation?.[0]?.id}
          asterRecommendation={asterRecommendation?.[0]}
          productId={productId}
          catId={catId}
          insiderData={insiderReducer?.insider && insiderReducer?.insider[insiderRecommendation?.[0]?.id]}
          analyticsProps={analyticsProps}
          setShowBrandCarousel={setShowBrandCarousel}
        />
      )}
      <Container>
        <RichMediaBanners
          sku={detailsData?.sku}
          mediaGalleryEntries={detailsData?.mediaGalleryEntries}
          scrollRef={scrollRef}
          setShowVideo={setShowVideo}
          setSelectedMediaId={setSelectedMediaId}
        />
      </Container>
      <>
      {showCategoryCarousel ? (
        (categoryProducts?.data?.length > 4) && (
          <CommonProductCarousel
            brandId={catLID}
            isLoading={isLoading}
            data={{ productList: categoryProducts }}
            title={`${t('ProductDetail.moreFrom')} ${catLID_name}`}
            showViewAllLink={categoryProducts?.data?.length > 5}
            viewAllLink={getViewAllLink(categoryProducts, 'category')}
            page={referrerPage}
            emptySphValues={emptySphValues}
          />
        )
      ) : (
        <InsiderRecCarousel
          insiderRecommendation={insiderRecommendation?.[1]}
          variationId={insiderRecommendation?.[1]?.id}
          asterRecommendation={asterRecommendation?.[1]}
          productId={productId}
          catId={catId}
          insiderData={
            insiderReducer?.insider &&
            insiderReducer?.insider[insiderRecommendation?.[1]?.id]
          }
          analyticsProps={analyticsProps}
          setShowCategoryCarousel={setShowCategoryCarousel}
        />
      )}
        <InsiderRecCarousel
          insiderRecommendation={insiderRecommendation?.[2]}
          variationId={insiderRecommendation?.[2]?.id}
          asterRecommendation={asterRecommendation?.[2]}
          productId={productId}
          catId={catId}
          insiderData={insiderReducer?.insider && insiderReducer?.insider[insiderRecommendation?.[2]?.id]}
          analyticsProps={analyticsProps}
        />
      </>
    </ProductDetailsStyled>
  );
};
ProductBottom.propTypes = {
  skuId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  brandId: PropTypes.string,
  catId: PropTypes.string,
  detailsData: PropTypes.object,
  referrerPage: PropTypes.string,
  scrollRef: PropTypes.object,
  fbtCondition: PropTypes.bool,
  pdpUpSellingFlag: PropTypes.string,
  analyticsProps: PropTypes.object,
};
ProductBottom.defaultProps = {
  skuId: 0 || '',
  detailsData: {},
  referrerPage: '',
  scrollRef: {},
  fbtCondition: false,
  pdpUpSellingFlag: '',
  analyticsProps: {},
};

export default ProductBottom;
